import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Menu } from "@/components/Menu";
import { MenuGeneral } from "@/components/MenuGeneral";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { CartDrawer } from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="App relative">
      <Header />
      <main>
        <Hero />
        <Menu />
        <MenuGeneral />
        <About />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <CartDrawer />
    </div>
  );
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
